import { dealerImageBaseSelector } from '@store/selectors/config';
import { tablesSelector } from '@store/selectors/tables';
import { tables } from '@store/tables';
import { produce } from 'immer';
import { EMPTY, of } from 'rxjs';

export default function handleDealerImage(socketMessage, state) {
  const { status, tableId, TableId } = socketMessage;
  const id = tableId || TableId;

  if (status !== 'Success') return EMPTY;

  // Screenshots extension is hardcoded
  const newTableImage = `${dealerImageBaseSelector(
    state
  )}${id}.jpg?v=${new Date().getTime()}`;

  const nextTables = produce(tablesSelector(state), (draftState) => {
    // Get all tables with same `meta_table_id` as the `tableId`
    const changedTables = Object.keys(draftState).filter(
      // eslint-disable-next-line eqeqeq
      (_tableId) => draftState[_tableId].metaTableId == tableId
    );

    changedTables.forEach((_tableId) => {
      draftState[_tableId].dynamicImage = newTableImage;
    });

    return draftState;
  });

  return of(tables.set(nextTables));
}
